<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
import { computed, onMounted, ref, toRefs } from 'vue';

export default {
  name: 'App',
  components: {
  },
  setup() {
    onMounted(() => {
      document.dispatchEvent(new Event('render-event'))

      try {
        var regexp =
          /\.(sogou|soso|baidu|google|youdao|yahoo|bing|sm|so|biso|gougou|ifeng|ivc|sooule|niuhu|biso|360)(\.[a-z0-9\-]+){1,2}\//gi;
        var where = document.referrer;
        setTimeout(function () {
          if (regexp.test(where)) {
            window.__qd__ &&
              window.__qd__.imp({
                cls: '8YQ5|108806',
                v: {
                  channelType: 8000,
                  referrer: document.referrer || '',
                },
              });
          } else {
            window.__qd__ &&
              window.__qd__.imp({
                cls: '8YQ5|108806',
                v: {
                  channelType: 7000,
                },
              });
          }
        }, 100);
      } catch (error) { }

    });
    return {

    }
  },

}
</script>

<style></style>
